module.exports = __webpack_public_path__ + "img/login.d814adb7.png";